<div class="multiLine wrappInside">
    <div class="mitemWrapp">
        <form [formGroup]="rfqForm">
        <table>
            <thead>
            <tr>
                <th>S. No.</th>
                <th>
                <input type="checkbox" [checked]="isAllSelected()" (change)="toggleSelectAll($event)" />
                </th>
                <th>Part Name</th>
                <th>Part Code</th>
                <th>Part Description</th>
                <th>Commodity</th>
                <th>2D/3D File</th>
                <th>Attachment</th>
                <th>Customer MOQ</th>
                <th>Order Type</th>
                <th>Annual Req</th>
                <th>Action</th>
            </tr>
            </thead>
            <tbody formArrayName="lineItems">
            <ng-container *ngFor="let item of lineItems().controls; let i = index" [formGroupName]="i">
            <tr >
                <!-- <div> -->
                <td>{{ i + 1 }}</td>
                <td>
                    <input type="checkbox" [formControlName]="'selected'" (change)="toggleSelectSingle($event)" />
                </td>
                <td>
                    <div class="formGroup">
                        <mat-form-field appearance="outline">
                            <input matInput formControlName="partName" />
                        </mat-form-field>
                    </div>
                </td>
                <td>
                    <div class="formGroup">
                        <mat-form-field appearance="outline">
                            <input matInput formControlName="partCode" />
                        </mat-form-field>
                    </div>    
                </td>
                <td>
                    <div class="formGroup">
                        <mat-form-field appearance="outline">
                            <input matInput formControlName="partDescription" />
                        </mat-form-field>
                    </div>  
                </td>
                <td>
                    <div class="formGroup">
                        <mat-form-field appearance="outline">
                            <mat-select formControlName="commodity">
                                <mat-option value="Aluminum">Aluminum</mat-option>
                                <mat-option value="Steel">Steel</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </td>
                <td>
                    <div class="formGroup">
                        <mat-form-field appearance="outline">
                            <mat-select formControlName="fileType">
                                <mat-option value="Yes">Yes</mat-option>
                                <mat-option value="No">No</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </td>
                <td>
                    <div class="commonUpload">
                        <app-upload-dnd
                          (fileUploadEvent)="fileUploadEvent($event)"
                          [documentInfo]="documentInfo"
                          [fileUploadConfig]="fileUploadConfig"
                          [resetFileUpload]="resetFileUpload"
                          [showDragDrop]="false"
                        ></app-upload-dnd>
                    </div>
                    <!-- <input type="file" formControlName="attachment" /> -->
                </td>
                <td>
                    <div class="formGroup">
                        <mat-form-field appearance="outline">
                            <input matInput formControlName="customerMOQ" />
                        </mat-form-field>
                    </div> 
                </td>
                <td>
                    <div class="formGroup">
                        <mat-form-field appearance="outline">
                            <mat-select formControlName="orderType">
                                <mat-option value="One Time">One Time</mat-option>
                                <mat-option value="Recurring">Recurring</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </td>
                <td>
                    <div class="formGroup">
                        <mat-form-field appearance="outline">
                            <input matInput formControlName="annualReq" />
                        </mat-form-field>
                    </div>
                </td> 
                <td>
                    <div class="actionBtn">
                        <button type="button" (click)="deleteLineItem(i)">
                            <lucide-icon name="trash-2" color="#666" [size]="20"></lucide-icon>
                        </button>
                        <button type="button" (click)="addSubLineItem(i)">
                            <lucide-icon name="plus" color="#666"  [size]="20"></lucide-icon>
                        </button>
                    </div>
                </td>
            </tr>   
            <tr>
                <td colspan="11" *ngIf="getSubLineItems(i)?.length" class="p-0">
                    <!--  Nested Table for SubItems -->
                    <table class="childLinitem">
                        <tbody formArrayName="subItems">
                        <tr *ngFor="let subItem of getSubLineItems(i)?.controls; let j = index" [formGroupName]="j">
                            
                            <td>{{ i + 1 }}</td>
                            <td>
                                <input type="checkbox" [formControlName]="'selected'" (change)="toggleSelectSingle($event)" />
                            </td>
                            <td>
                                <div class="formGroup">
                                    <mat-form-field appearance="outline">
                                        <input matInput formControlName="subPartName" />
                                    </mat-form-field>
                                </div>
                            </td>
                            <td>
                                <div class="formGroup">
                                    <mat-form-field appearance="outline">
                                        <input matInput formControlName="subPartCode" />
                                    </mat-form-field>
                                </div>
                            </td>
                            <td>
                                <div class="formGroup">
                                    <mat-form-field appearance="outline">
                                        <input matInput formControlName="subDescription" />
                                    </mat-form-field>
                                </div>
                            </td>
                            <td>
                                <div class="formGroup">
                                    <mat-form-field appearance="outline">
                                        <mat-select formControlName="subCommodity">
                                            <mat-option value="Aluminum">Aluminum</mat-option>
                                            <mat-option value="Steel">Steel</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </td>
                            <td>
                                <div class="formGroup">
                                    <mat-form-field appearance="outline">
                                        <mat-select formControlName="subFileType">
                                            <mat-option value="Yes">Yes</mat-option>
                                            <mat-option value="No">No</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </td>
                            <td>
                                <div class="commonUpload">
                                    <app-upload-dnd
                                        (fileUploadEvent)="fileUploadEvent($event)"
                                        [documentInfo]="documentInfo"
                                        [fileUploadConfig]="fileUploadConfig"
                                        [resetFileUpload]="resetFileUpload"
                                        [showDragDrop]="false"
                                    ></app-upload-dnd>
                                </div>
                            </td>
                            <td>
                                <div class="formGroup">
                                    <mat-form-field appearance="outline">
                                        <input matInput formControlName="subCustomerMOQ" />
                                    </mat-form-field>
                                </div> 
                            </td>
                            <td>
                                <div class="formGroup">
                                    <mat-form-field appearance="outline">
                                        <mat-select formControlName="subOrderType">
                                            <mat-option value="One Time">One Time</mat-option>
                                            <mat-option value="Recurring">Recurring</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </td>
                            <td>
                                <div class="formGroup">
                                    <mat-form-field appearance="outline">
                                        <input matInput formControlName="subAnnualReq" />
                                    </mat-form-field>
                                </div>
                            </td> 
                            <td>
                                <div class="actionBtn">
                                    <button type="button" (click)="removeSubLineItem(i, j)">
                                        <lucide-icon name="trash-2" color="#666" [size]="20"></lucide-icon>
                                    </button>
                                </div>
                                
                            </td>
                            
                        </tr>
                        </tbody>
                    </table>
                </td>
            </tr>
            </ng-container>
            </tbody>
        </table>
        </form>
    </div>
    <div class="btmButtons flex">
        <button mat-button class="btnCustom btn-primary" type="button" (click)="addLineItem()">+ Add Row</button>
        <button mat-button class="btnCustom btn-primary" (click)="onSubmit()" type="submit">Save</button>
        <button mat-button class="btnCustom btn-primary" (click)="onSubmit()" type="submit">Save & Continue</button>
    </div>
    
</div>